
import { defineComponent, ref } from "vue";
import BaseExpansion from "../base/BaseExpansion.vue";
import BaseSvg from "../base/BaseSvg.vue";
import TripDiscount from "../bookingflow/steps/tripdetails/TripDiscount.vue";

export default defineComponent({
	components: { BaseExpansion, TripDiscount, BaseSvg },
	props: {
		applyVoucher: Boolean
	},
	setup(props) {
		const expanded = ref(false);

		const toggle = () => {
			expanded.value = !expanded.value;
		};

		return { expanded, toggle };
	},
});
